import React from 'react'

let Footer = () => {

    return <div className="footer-container">
        <p className="footer-text">
            Follow Us On <br />
            <a href="https://twitter.com/kvs1297" className="link-icon"><i class="fab fa-twitter"></i></a>
            <a href="https://github.com/vermakartik" className="link-icon"><i class="fab fa-github"></i></a>
            <a href="https://talexstudios.in/blog" className="link-icon">b</a>
            <a href="https://www.instagram.com/me.kartik.verma/" className="link-icon"><i class="fab fa-instagram"></i></a>
            <a href="https://www.linkedin.com/in/kartik-verma/" className="link-icon"><i class="fab fa-linkedin"></i></a>
        </p><br />
        <p className="footer-text copy-footer">CopyRight &copy; Talex Studios. All Right Reserved - 2020.</p>
    </div>
}

export default Footer